/* global game, Phaser, social */

Game.States.Boot = function( game ) {

}

Game.States.Boot.prototype = {

	preload: function() {

		game.load.image( 'progressBar', '/assets/games/star-raid/images/loading.png' );

		// Align game to the center of the available space.
		game.scale.pageAlignHorizontally = true;
		game.scale.pageAlignVertically = true;

		// Make game stretch to fill screen fully
		game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;

		// Make game nice and crisp (as crispy as can be).
		game.renderer.renderSession.roundPixels = true;
		Phaser.Canvas.setImageRenderingCrisp( game.canvas, true );
		game.stage.smoothed = false;
		game.antialias = false;

		// update game scale.
		game.scale.refresh();

		// Set a background color.
		game.stage.backgroundColor = Game.background_color;

		// Setup arcade physics.
		game.physics.startSystem( Phaser.Physics.ARCADE );
		game.physics.arcade.TILE_BIAS = 8;

		Game.Utils.Camera.init();

		game.camera.roundPx = true;

		if ( Game.desiredFps ) {
			game.time.desiredFps = Game.desiredFps;
		}

	},

	create: function() {

		// switch to the loading state
		game.state.start( 'load' );

		// game.renderer.renderSession.roundPixels = true; // Round pixels for the renderer
		// Phaser.Canvas.setImageRenderingCrisp( game.canvas ); // Set image rendering to be crisp (no antialiasing)
		// Phaser.Stage.scaleMode = Phaser.StageScaleMode.SHOW_ALL; // Ensure the scale mode shows all content

	}

};
